// popup.js
(function () {

async function renderTextOnCanvas(canvas, imageUrl, names) {
    const ctx = canvas.getContext("2d");
    
    try {
        // Load image
        const img = await loadImage(imageUrl);
        
        // Determine aspect ratio (default 3:4, or 5:7 if selected)
        const is5070Selected = checkAspectRatioSelection();
        const targetRatio = is5070Selected ? 5/7 : 3/4;
        
        // Calculate canvas dimensions maintaining aspect ratio
        const { width, height } = calculateCanvasDimensions(img, targetRatio);
        
        // Setup canvas
        canvas.width = width;
        canvas.height = height;
        
        // Draw image (centered and cropped to fit)
        drawCenteredImage(ctx, img, width, height);
        
        // Add text overlay
        const petName = names.name1?.toUpperCase() || "LEO";
        addTextWithShadow(ctx, petName, width, height);
        
        return canvas;
    } catch (error) {
        console.error("Canvas rendering failed:", error);
        throw error;
    }
}

// Helper function to load image with Promise
function loadImage(src) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => resolve(img);
        img.onerror = () => reject(new Error("Failed to load image"));
        img.src = src;
    });
}

// Check if 50:70 aspect ratio is selected
function checkAspectRatioSelection() {
    const imageManager = window.imageProcessingManager;
    return imageManager?.currentCropRatio && 
            Math.abs(imageManager.currentCropRatio - 5/7) < 0.01;
}

// Calculate optimal canvas dimensions
function calculateCanvasDimensions(img, targetRatio) {
    const imgRatio = img.width / img.height;
    
    if (imgRatio > targetRatio) {
        // Image is wider - fit by height
        const height = img.height;
        const width = height * targetRatio;
        return { width, height };
    } else {
        // Image is taller - fit by width  
        const width = img.width;
        const height = width / targetRatio;
        return { width, height };
    }
}

// Draw image centered on canvas
function drawCenteredImage(ctx, img, canvasWidth, canvasHeight) {
    const offsetX = (img.width - canvasWidth) / 2;
    const offsetY = (img.height - canvasHeight) / 2;
    
    ctx.clearRect(0, 0, canvasWidth, canvasHeight);
    ctx.drawImage(
        img, 
        offsetX, offsetY, canvasWidth, canvasHeight,  // source crop
        0, 0, canvasWidth, canvasHeight               // destination
    );
}

// Add text with professional shadow effects
function addTextWithShadow(ctx, text, width, height) {
    // Calculate responsive font size
    let fontSize = Math.max(Math.floor(width / 5), 60);
    const maxWidth = width * 0.85;
    
    // Set initial font and measure text
    ctx.font = `900 ${fontSize}px Montserrat, 'Arial Black', sans-serif`;
    ctx.textAlign = "center";
    ctx.textBaseline = "bottom";
    
    // Adjust font size if text is too wide
    let textWidth = ctx.measureText(text).width;
    if (textWidth > maxWidth) {
        fontSize = Math.floor(fontSize * (maxWidth / textWidth));
        ctx.font = `900 ${fontSize}px Montserrat, 'Arial Black', sans-serif`;
    }
    
    // Position text at top of canvas
    const x = width / 2;
    const y = height * 0.2;
    
    // Apply layered shadow effects for depth
    const shadowLayers = [
        { color: "rgba(0, 0, 0, 0.8)", blur: fontSize * 0.07, offsetY: fontSize * 0.03 },
        { color: "rgba(0, 0, 0, 0.6)", blur: fontSize * 0.12, offsetY: fontSize * 0.05 },
        { color: "rgba(255, 255, 255, 0.2)", blur: fontSize * 0.04, offsetY: 0 }
    ];
    
    ctx.fillStyle = "white";
    
    shadowLayers.forEach(shadow => {
        ctx.shadowColor = shadow.color;
        ctx.shadowBlur = shadow.blur;
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = shadow.offsetY;
        ctx.fillText(text, x, y);
    });
}

// Function to update preview image with canvas rendering
async function updatePreviewImage(imageUrl, petName) {
    try {
        // Create a temporary canvas for rendering
        const canvas = document.createElement('canvas');
        const names = { name1: petName };
        
        // Render text on canvas
        await renderTextOnCanvas(canvas, imageUrl, names);
        
        // Convert canvas to base64 and update preview
        const base64Image = canvas.toDataURL('image/jpeg', 0.9);
        
        
        return base64Image;
    } catch (error) {
        console.error("Failed to update preview:", error);
        // Fallback to original image if rendering fails
        return imageUrl;
    }
}

window.showTextPopup = function createDialog(imageUrl) {
    // Create container div that will hold everything
    const container = document.createElement("div");
    container.style.cssText = `
        display: block;
        position: fixed;
        z-index: -1;
        opacity: 0;
    `;
    
    // Add the active class styles
    container.classList.add('active');
    container.style.zIndex = '9999';
    container.style.opacity = '1';

    // Add styles
    const style = document.createElement("style");
    style.textContent = `
        @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@900&display=swap');
        @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600&display=swap');
    
        .dialog-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.7);
            display: flex;
            align-items: center;
            justify-content: center;
            backdrop-filter: blur(3px);
        }
        
        .dialog-container {
            background-color: white;
            border-radius: 16px;
            padding: 24px;
            width: 80%;
            max-width: 500px;
            max-height: 90vh;
            overflow-y: auto;
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
            display: flex;
            flex-direction: column;
            position: relative;
        }
        
        .dialog-header {
            text-align: center;
            margin-bottom: 20px;
            padding-bottom: 15px;
            border-bottom: 1px solid #f0f0f0;
        }
        
        .dialog-title {
            font-size: 1.5rem;
            font-weight: 600;
            margin: 0;
            font-family: 'Montserrat', sans-serif;
            color: #000000;
        }
        
        .close-button {
            position: absolute;
            top: 20px;
            right: 20px;
            background: none;
            border: none;
            cursor: pointer;
            font-size: 30px;
            color: #555;
            transition: color 0.2s;
            width: 32px;
            height: 32px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .dialog-content {
            margin-bottom: 0;
            display: flex;
            flex-direction: column;
        }
        
        .form-group {
            margin-bottom: 15px;
        }
        
        .dialog-input {
            width: 100%;
            padding: 10px 12px;
            border: 1px solid #E2E8F0;
            border-radius: 4px;
            font-size: 16px;
            background-color: #F7FAFC;
            color: #000000;
            transition: all 0.2s;
            font-family: 'Montserrat', sans-serif;
        }
        
        .dialog-input:focus {
            outline: none;
            border-color: #4A7DBD;
            background-color: white;
            box-shadow: 0 0 0 2px rgba(74, 125, 189, 0.15);
        }
        
        .dialog-input:hover {
            border-color: #CBD5E0;
        }
        
        .dialog-input::placeholder {
            color: #A0AEC0;
        }
        .inputs-container .dialog-input::placeholder,
        .subtitle-container .dialog-input::placeholder {
            font-size: 12px;
        }
        .inputs-container .dialog-input,
        .subtitle-container .dialog-input {
            box-sizing: border-box;
        }
        .preview-container {
            margin-top: 0;
            margin-bottom: 20px;
            text-align: center;
            border-radius: 8px;
            overflow: hidden;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            width: 100%;
            max-width: 300px;
            margin-left: auto;
            margin-right: auto;
            aspect-ratio: 3/4; /* Default 30x40 aspect ratio, can be changed dynamically */
            transition: aspect-ratio 0.3s ease;
        }
        
        .preview-image {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
        }
        
        .inputs-container {
            display: flex;
            gap: 12px;
            margin-bottom: 20px;
        }
        
        .dialog-footer {
            display: flex;
            justify-content: center;
            gap: 12px;
            margin-top: 20px;
            padding-top: 20px;
            border-top: 1px solid #f0f0f0;
        }
        
        .btn {
            padding: 10px 20px;
            border-radius: 4px;
            cursor: pointer;
            font-weight: 500;
            font-family: 'Montserrat', sans-serif;
            font-size: 14px;
            transition: all 0.2s;
            border: none;
        }
        
        .btn-cancel {
            background-color: #EDF2F7;
            color: #000000;
        }
        
        .btn-cancel:hover {
            background-color: #E2E8F0;
        }

        .btn-revert {
            background-color: #838383;
            color: white;
            padding: 12px 25px;
            font-size: 16px;
            font-weight: bold;
            border: none;
            border-radius: 8px;
            cursor: pointer;
            margin: 0 10px;
            text-transform: uppercase;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            transition: background-color 0.2s ease-in-out;
            font-family: inherit;
        }
        
        .btn-revert:hover {
            background-color: #636363;
        }
        
        .btn-submit {
            background-color: rgb(74, 125, 189);
            color: white;
            padding: 12px 25px;
            font-size: 16px;
            font-weight: bold;
            border: none;
            border-radius: 8px;
            cursor: pointer !important;
            margin: 0px 10px;
            text-transform: uppercase;
            box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 8px;
            transition: background-color 0.2s ease-in-out;
            font-family: inherit;
        }
        
        .btn-submit:hover {
            background-color: #3a6dad;
        }


    `;
    
    container.innerHTML = `
        <div class="dialog-overlay">
        <div class="dialog-container">
            <button class="close-button"><font style="vertical-align: inherit;"><font style="vertical-align: inherit;">×</font></font></button>
            <div class="dialog-header">
                <h3 class="dialog-title"><font style="vertical-align: inherit;"><font style="vertical-align: inherit;">Add Your Names</font></font></h3>
            </div>
            <div class="dialog-content">
                <div class="preview-container">
                    <img class="preview-image" alt="Preview" src="">
                </div>
                <div class="inputs-container">
                    <div style="flex: 1 1 0%;">
                    <label class="subtitle-label" for="nameInput1"><font style="vertical-align: inherit;"><font style="vertical-align: inherit;">Pet Name</font></font></label><input type="text" id="nameInput1" class="dialog-input" placeholder="Enter pet name" maxlength="15">
                    <div class="nameInput1-char-counter" style="font-size: 12px; color: rgb(102, 102, 102); margin-top: 5px; display: none;"></div>
                    <div class="nameInput1-warning" style="font-size: 12px; color: rgb(231, 76, 60); margin-top: 5px; display: none;"><font style="vertical-align: inherit;"><font style="vertical-align: inherit;">Person One Name may be truncated</font></font></div>
                    </div>
                </div>
            </div>
            <div class="dialog-footer"><button class="btn btn-revert"><font style="vertical-align: inherit;"><font style="vertical-align: inherit;">Go Back</font></font></button><button class="btn btn-submit"><font style="vertical-align: inherit;"><font style="vertical-align: inherit;">Continue</font></font></button></div>
        </div>
        </div>`;
    
    // Add style 
    container.appendChild(style);
    
    const popupOpenButton = document.getElementById("aurora-upload-button");
    const closeButton = container.querySelector(".dialog-container .close-button");
    const revertButton = container.querySelector(".dialog-footer .btn.btn-revert");
    const submitButton = container.querySelector(".dialog-footer .btn.btn-submit");
    const previewImage = container.querySelector(".dialog-content .preview-container .preview-image");
    const nameInput1 = container.querySelector("#nameInput1");
    
    // Store the current base64 image for later use
    let currentBase64Image = imageUrl;
    
    // Initialize preview with default "LEO" text
    if (previewImage) {
        // Show loading state initially
        
        // Render initial preview with "LEO"
        updatePreviewImage(imageUrl, "LEO").then(base64 => {
            currentBase64Image = base64;
            previewImage.src = base64;
        }).catch(error => {
            console.error("Error rendering initial preview:", error);
            previewImage.src = imageUrl;
        });
    }

    // Real-time input handling with debouncing
    let renderTimeout;
    nameInput1.addEventListener("input", async (e) => {
        const petName = e.target.value.trim();
        
        // Clear previous timeout
        clearTimeout(renderTimeout);
        
        // Show loading state
        
        // Debounce the rendering to avoid too many rapid calls
            try {
                if (petName === '') {
                    // If input is empty, show original image
                    currentBase64Image = await updatePreviewImage(imageUrl, 'LEO');
                    previewImage.src = currentBase64Image;
                } else {
                    // Update preview with text overlay
                    currentBase64Image = await updatePreviewImage(imageUrl, petName);
                    previewImage.src = currentBase64Image;
                }
            } catch (error) {
                console.error("Error updating preview:", error);
            }

    });

    closeButton.addEventListener("click", () => {
        // Close dialog - remove from DOM
        clearTimeout(renderTimeout);
        nameInput1.value = '';
        previewImage.src = '';
        document.body.removeChild(container);
    });
    
    revertButton.addEventListener("click", () => {
        // Handle text cancelled logic would go here
        console.log("Text cancelled");
        clearTimeout(renderTimeout);
        if (window.promptVisible) {
          window.showPromptPopup(window.selectedFile);
        } else {
          popupOpenButton?.click();   
        }
        nameInput1.value = '';
        previewImage.src = '';
        document.body.removeChild(container);
    });
    
    submitButton.addEventListener("click", async () => {
        // Close dialog with success - pass the current base64 image
        console.log("Dialog submitted with value:", nameInput1.value);
        console.log("Final base64 image:", currentBase64Image);
        
        // You can emit an event or call a callback with the final image
        if (window.onPetPopupSubmit) {
            window.onPetPopupSubmit({
                petName: nameInput1.value,
                base64Image: currentBase64Image
            });
        }
        if (nameInput1.value){window.nonWatermarkResultImg = await updatePreviewImage(window.resultImageUrl, nameInput1.value)};
        if (nameInput1.value){window.showResultPopup(currentBase64Image)} else{window.showResultPopup(imageUrl)};
        clearTimeout(renderTimeout);
        nameInput1.value = '';
        previewImage.src = '';
        document.body.removeChild(container);
    });

    // Append to document body
    document.body.appendChild(container);

    // Focus on the input field
    setTimeout(() => nameInput1.focus(), 100);

    return;
}

})();